import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CompanySettingsData } from '../../interfaces';

@Component({
  selector: 'app-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.scss']
})
export class StatusLabelComponent implements OnInit {
  @Input() label: CompanySettingsData | null = null;
  @Input() shouldCropLabel: boolean = false;
  @Input() shouldHideUnknownTooltip: boolean = false;

  croppedLength: number = 15;

  unknownLabelName = this.translate.instant('company.settings.rules.unknown');

  unknownLabel: CompanySettingsData = {
    name: this.unknownLabelName,
    color: { id: 'UNKNOWN', bg: '#fff', fg: 'var(--color-text-secondary)', name: this.unknownLabelName }
  };

  constructor(private readonly translate: TranslateService) {}

  ngOnInit(): void {
    this.label = this.label ?? this.unknownLabel;
    this.label.color = this.label.color ?? this.unknownLabel.color;
  }
}
